module.exports = __webpack_public_path__ + "assets/img/zy1.e6f1bb9e.png";